
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[subdomain]/book",
      function () {
        return require("private-next-pages/[subdomain]/book/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[subdomain]/book"])
      });
    }
  